import React from "react";
import { LineInput } from "components/Inputs/LineInput";
export const NumericInput = ({ onChange, ...props }) => {
    return (React.createElement(LineInput, { onChange: (x) => {
            const numeric = Number(x);
            if (!isNaN(numeric)) {
                onChange(numeric);
            }
            else {
                onChange(0);
            }
        }, ...props }));
};
